import { profile } from "./_duck"
import * as types from "./types"

export const getRatingsRequest = profile.createAction(types.RATINGS_GET_REQUEST)
export const getRatingsSuccess = profile.createAction(types.RATINGS_GET_SUCCESS)
export const getRatingsFailure = profile.createAction(types.RATINGS_GET_FAILURE)
